var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', {
    staticStyle: {
      "height": "100"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Print AWB")])])])]), _vm._v(" "), _c('legend', [_c('form', [_c('div', {
    staticClass: "form-group-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Enter upto 50 AWB(s). Use comma as a separator between 2 AWB(s) "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBNumber),
      expression: "AWBNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max_awbnumbers'),
      expression: "'required|max_awbnumbers'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWBNumber')
    },
    attrs: {
      "type": "text",
      "rows": 5,
      "placeholder": " Enter AWB Number",
      "name": "AWB Number",
      "id": "AWBNumber"
    },
    domProps: {
      "value": (_vm.AWBNumber)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchAWB()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB Number')),
      expression: "errors.has('AWB Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('AWB Number')))])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Validate AWB(s)"
    },
    on: {
      "click": function($event) {
        _vm.searchAWB()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Validate AWB(s)")]), _vm._v("   \n            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])]), _vm._v(" "), _c('legend', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showdetails == true),
      expression: "showdetails==true"
    }]
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 mb-2"
  }, [_c('label', [_vm._v("Validated AWB(s): " + _vm._s(_vm.validatedawb.length))]), _vm._v(" "), _c('b-input-group', [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.validatedawb), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))])])
  }))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mb-2"
  }, [_c('label', [_vm._v("Print Options: "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.pagelist,
      "append-to-body": true,
      "name": "noofcopies"
    },
    on: {
      "select": _vm.selectNoOfCopies
    },
    model: {
      value: (_vm.noofcopies),
      callback: function($$v) {
        _vm.noofcopies = $$v
      },
      expression: "noofcopies"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mb-2"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Print AWB(s)"
    },
    on: {
      "click": _vm.printAWB
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print AWB(s)")])])], 1)])])], 1), _vm._v(" "), (_vm.showdetails) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.printMultipleAwbs.length > 0) ? _c('div', {
    attrs: {
      "id": "printMultiple"
    }
  }, [_vm._l((_vm.printMultipleAwbs), function(item) {
    return (_vm.noofcopies === 1) ? _c('LR-Copy', {
      key: _vm.noofcopies + item.awbnumber,
      attrs: {
        "selectedData": item
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.printMultipleAwbs), function(item) {
    return (_vm.noofcopies === 2) ? _c('LR-Copy', {
      key: _vm.noofcopies + item.awbnumber,
      attrs: {
        "selectedData": item,
        "copytype": true
      }
    }) : _vm._e()
  })], 2) : _vm._e()]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2745a08a","hasScoped":false}!./src/modules/cargobooking/views/printAWB/printAWB.component.html
// module id = 1232
// module chunks = 3